import PageManager from '../page-manager';

export default class RSS extends PageManager {}




// WEBPACK FOOTER //
// ./assets/js/theme/rss.js